import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { css, cx } from 'linaria';
const buttonStyles = "b18soqoe";
/**
 * The standard button component. Provides a few different stylistic treatments
 * per design standards. By default, returns a `<button>` element, but if an `href`
 * value is passed in as a prop, the element will be an anchor/link pointing
 * to that url.
 *
 * return (
 *  <div>
 *    <Button onClick={myCallback}>I am a button. I call myCallback when clicked.</Button>
 *    <Button href="http://google.com">I link to Google</Button>
 *  </div>
 * )
 * ```
 */

export const Button = forwardRef(function Button({
  children,
  variant = 'primary',
  size,
  href,
  disabled,
  className: passedClassName,
  ...remaining
}, ref) {
  const className = cx(buttonStyles, passedClassName, variant, size, disabled && 'disabled');
  const elementProps = {
    className,
    href,
    disabled,
    ref,
    ...remaining
  }; // If an href is passed, element should be an anchor (hyperlink)

  if (href) return <a {...elementProps}>{children}</a>; // It's a button

  return <button {...elementProps}>{children}</button>;
});
Button.propTypes = {
  // Content of the button (e.g. button label)
  children: PropTypes.node.isRequired,
  // Visual variant of the button, from design standards
  variant: PropTypes.oneOf(['primary', 'secondary', 'outline', 'brand', 'emphasized', 'inline']),
  // Size of the button
  size: PropTypes.oneOf(['normal', 'large', 'small']),
  // Destination url for the button - if provided, will render the button as an anchor styled like a button
  href: PropTypes.string,
  // CSS class name if styles need to be provided/overridden.
  className: PropTypes.string
};
Button.defaultProps = {
  variant: 'primary',
  size: 'normal',
  href: undefined,
  className: null
};

require("./button.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./button.js");